import { z } from 'zod';

export const alfred = {
  streaming: { path: `alfred/v1` },
  feedback: { path: 'alfred/v1/feedback' },
  contentQuestions: {
    getQuestions: {
      path: 'question-generator/v1/questions',
      schema: z.object({
        questions: z.array(z.string()),
      }),
    },
  },
};
